import { useState } from "react";
import styled from "styled-components";

import { Button, Color, Flex, Text } from "src/elements";
import { useStoreCategoriesModal } from "src/modals/StoreCategories/store/hooks";
import { ResponseGetStoresList } from "@CommonApi/stores/list";
import { useStoresPage } from "../store/hooks";
import { useNavigation } from "src/utils/navigation";
import { pages } from "src/utils";

const StoreCard = styled(Flex)`
  gap: 10px;
  width: 100%;
  padding: 10px;
  margin-bottom: 8px;
  box-shadow: 0 6px 25px rgba(233, 233, 233, 0.8);
  border-radius: 4px;
  background-color: ${Color.white};
`;

const Value = styled(Flex)`
  line-height: 20px;
  font-size: 14px;
  font-weight: 400;
  color: ${Color.textMain};
`;

const Id = styled(Flex)`
  align-items: center;
  justify-content: center;
  min-width: 20px;
  min-height: 20px;
  padding: 0 4px;
  border: 1px solid ${Color.primary};
  border-radius: 10px;
`;

interface Props {
  store: ResponseGetStoresList["data"][0];
}

export const StoreRow = ({ store }: Props) => {
  const { updateStoreStatus: _updateStoreStatus } = useStoresPage();
  const { openStoreCategoriesModal } = useStoreCategoriesModal();
  const { navigate } = useNavigation();

  const isActive = store.status === "ACTIVE";
  const [isLoading, setIsLoading] = useState(false);

  const updateStoreStatus = async (status: ResponseGetStoresList["data"][0]["status"]) => {
    setIsLoading(true);
    await _updateStoreStatus(store.id, status);
    setIsLoading(false);
  };

  const activateStore = () => updateStoreStatus("ACTIVE");

  const archiveStore = () => updateStoreStatus("ARCHIVED");

  return (
    <StoreCard>
      <Flex flexGrow gap="10px">
        <Flex column gap="8px">
          <Flex justify="center">
            <Text variant="small2" color={Color.spaceGray}>
              ID
            </Text>
          </Flex>

          <Id>
            <Text variant="caption2" color={Color.primary}>
              {store.id}
            </Text>
          </Id>
        </Flex>

        <Flex column gap="8px">
          <Flex>
            <Text variant="small2" color={Color.spaceGray}>
              Store Code
            </Text>
          </Flex>
          <Value>{store.code}</Value>
        </Flex>
      </Flex>

      <Flex align="center" gap="8px">
        <Button
          color="greenSmoke"
          variant="inverted"
          onClick={() => navigate(pages.stores_storeId_Products, { storeId: store.id })}
          size="small"
        >
          Products
        </Button>

        <Button
          color="greenSmoke"
          variant="inverted"
          onClick={() => openStoreCategoriesModal(store)}
          size="small"
        >
          Categories
        </Button>

        {isActive ? (
          <Button
            color="yellow"
            variant="inverted"
            size="small"
            isLoading={isLoading}
            onClick={archiveStore}
          >
            Archive
          </Button>
        ) : (
          <Button
            color="yellow"
            variant="inverted"
            size="small"
            isLoading={isLoading}
            onClick={activateStore}
          >
            Restore
          </Button>
        )}
      </Flex>
    </StoreCard>
  );
};
